/** @format */
import { useRef } from 'react'
import { Tooltip } from '@king-design/react'
import styled from 'styled-components'
import { CopyButton } from 'src/components'

export interface TruncatedValueWithTooltipProps {
  className?: string
  value?: string
  copyable?: boolean
  children?: React.ReactNode
  showTooltip?: boolean
  style?: React.CSSProperties
  onClick?: () => void
}

const TruncatedValueWithTooltip: React.FC<TruncatedValueWithTooltipProps> = ({
  className,
  value,
  copyable,
  onClick,
  children,
  style,
  showTooltip = true
}) => {
  const text = children || value || '-'
  const textRef = useRef<HTMLSpanElement>(null)

  const textNode = (
    <span ref={textRef} onClick={() => onClick?.()} style={style}>
      {text}
    </span>
  )

  return (
    <div className={className}>
      <Tooltip content={value} theme="light" hoverable={true} disabled={!showTooltip}>
        {textNode}
      </Tooltip>
      {copyable ? <CopyButton text={value} /> : null}
    </div>
  )
}

export default styled(TruncatedValueWithTooltip)`
  min-width: 0;
  flex: 1;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  white-space: pre-wrap;
  line-height: 16px;
  .copy-button {
    margin-left: 4px;
  }
`
